<app-page-header title="O-Ring Cord" subtitle="O-Ring Cord Sealing Solutions to Match Your Needs."
  image="url(assets/site/images/general-header20.webp)"></app-page-header>

<div id="content" class="container">
  <h2>O-Ring Cord</h2>
  <p>O-ring cord is a continuous length of elastomer material with a consistent circular cross-section. It is used in
    various applications where standard O-rings may not be suitable or available. Marco Rubber & Plastics offers a wide
    variety of O-Ring cord. Our product experts can help you find the ideal solution for your custom project or
    prototype, and to match your specific application needs.</p>
  <ul>
    <li>Round Cross Sections 0.039" - 2.000"</li>
    <li>Square Cross Sections 0.099" - 1.000"</li>
    <li>4 Lobed Profile X-Ring Cord 0.103" - 1.000"</li>
    <li>Durometers from 40-90</li>
  </ul>
  <p>Non-Standard Colors Available</p>

  <h5>Materials Available</h5>
  <ul class="responsive-grid-list">
    <li>Buna-N (Nitrile)</li>
    <li>Viton® (Fluorocarbon)</li>
    <li>EPDM</li>
    <li>Silicone</li>
    <li>Neoprene Aflas</li>
    <li>Butyl</li>
    <li>Fluorosilicone</li>
    <li>Polyurethane</li>
    <li>Sponges</li>
    <li>Neoprene/ EPDM</li>
  </ul>
  <a routerLink="/inquiry-quote.htm" [queryParams]="{ material: 'O-Ring Cord' }">
    <button class="btn btn-primary">Request a Quote</button>
  </a>
  <br />
  <br />

  <!-- <h2>O-Ring Splicing Kits</h2>
  <div id="content" class="container">
    <div class="add-grid pb-20 related-links-grid-2-column">
      <div class="card p-20">
        <h4>Standad Splicing Kit Contents</h4>
        <ul>

          <li>Razor blade, splicing and cutting tool, adhesive.</li>
          <li>Seven feet each of 0.070, 0.103, 0.139, 0.210, 0.275 o-ring cord.</li>
        </ul>
        <h5>Materials Available</h5>
        <ul>
          <li>Buna</li>
          <li>Neoprene</li>
          <li>EPDM</li>
          <li>Viton®</li>
        </ul>
        <a routerLink="/inquiry-quote.htm" [queryParams]="{ material: 'Standad Splicing Kit' }">
          <button class="btn btn-primary">Request a Quote</button>
        </a>
      </div>
      <div class="card p-20">
        <h4>Metric Splicing Kit Contents</h4>
        <ul>
          <li>Razor blade, splicing and cutting tool, adhesive.</li>
          <li>One meter each of 1.6mm, 2.0mm, 2.4mm, 3.0mm, 3.5mm, 4.0mm, 5.0mm, 5.7mm, 8.4mm o-ring cord.</li>
        </ul>
        <h5>Materials Available</h5>
        <ul>
          <li>Buna</li>
        </ul>
        <a routerLink="/inquiry-quote.htm" [queryParams]="{ material: 'Metric Splicing Kit' }">
          <button class="btn btn-primary">Request a Quote</button>
        </a>
      </div>
      <div class="card p-20">
        <h4>Metric / American Splicing Kit Contents</h4>
        <ul>
          <li>Razor blade, splicing and cutting tool, adhesive.</li>
          <li>One meter each of 0.070, 0.103, 0.139, 0.210, 0.275, 1.6mm, 2.0mm, 2.4mm, 3.0mm, 3.5mm, 4.0mm, 5.0mm,
            5.7mm,
            8.4mm o-ring cord.</li>
        </ul>
        <h5>Materials Available</h5>
        <ul>
          <li>Buna</li>
        </ul>
        <a routerLink="/inquiry-quote.htm" [queryParams]="{ material: 'Metric / American Splicing Kit' }">
          <button class="btn btn-primary">Request a Quote</button>
        </a>
      </div>
      <div class="card p-20">
        <h4>4 Lobed Profile (Q) Splicing Kit Contents</h4>
        <ul>
          <li>Razor blade, splicing and cutting tool, adhesive.</li>
          <li>Seven feet each of 4 Lobed Profile X-Ring Cord in 0.070, 0.103, 0.139, 0.210, 0.275 o-ring cord.</li>
        </ul>
        <h5>Materials Available</h5>
        <ul>
          <li>Buna</li>
        </ul>
        <a routerLink="/inquiry-quote.htm" [queryParams]="{ material: '4 Lobed Profile (Q) Splicing Kit' }">
          <button class="btn btn-primary">Request a Quote</button>
        </a>
      </div>
      <div class="card p-20">

        <h4>Square Splicing Kit Contents</h4>
        <ul>
          <li>Razor blade, splicing and cutting tool, adhesive.</li>
          <li>Seven feet each of square cord in 0.099, 0.134, 0.156, 0.203, 0.266 o-ring cord.</li>
        </ul>
        <h5>Materials Available</h5>
        <ul>
          <li>Buna</li>
        </ul>
        <a routerLink="/inquiry-quote.htm" [queryParams]="{ material: 'Square Splicing Kit' }">
          <button class="btn btn-primary">Request a Quote</button>
        </a>
      </div>
      <div class="card p-20">


        <h4>90 Duro Splicing Kit Contents</h4>
        <ul>
          <li>Razor blade, splicing and cutting tool, adhesive.</li>
          <li>Seven feet each of 90 duro cord in 0.070, 0.103, 0.139, 0.210, 0.275 o-ring cord.</li>
        </ul>
        <h5>Materials Available</h5>
        <ul>
          <li>Buna</li>
        </ul>
        <a routerLink="/inquiry-quote.htm" [queryParams]="{ material: '90 Duro Splicing Kit' }">
          <button class="btn btn-primary">Request a Quote</button>
        </a>
      </div>
    </div>
  </div> -->
</div>

<app-cta-full-width></app-cta-full-width>
<app-related-links [columns]="'3'" [cards]="['splicing-kits', 'profiles-cord', 'material-quick-reference']"></app-related-links>